
import { useEffect, useState } from "react";
import { useAuth } from '../../hooks/useAuth';
import { isMobileVerified, storePatientSession } from '../../utils/storage/authStorage';
import { quickRegister, sendQuickOtp, verifyOtp } from '../../api/auth.api';
import StepperProgress from "../Reusablesteps/Stepperprogress";
import { BtnBack, BtnContinue } from "../Reusablecomponents/Button/Reusableutton";
import { useNavigate } from "react-router-dom";
// import content from './CareJourney.json'
import { BASE_URL } from "../../api/apiClient";
import { org_text } from "../../config";
export default function NewPatientScreen({
  onNext,
  onBack,
  stepIndex,
  totalSteps,
  patientState,
  onPatientStateChange,
}) {
  const [content,setContent]=useState({});
    useEffect(() => {
      const fetchContent = async () => {
        try {
          const res = await fetch(`${BASE_URL}/api/femcare/care-journey/?clinic=${org_text}`)
          const data = await res.json();
          setContent(data);
          console.log(data,"this is the dataaa from api")
        } catch (error) {
          console.log(error, "error while fetching the json of care journey");
        }
      }
      fetchContent();
    }, [])
  
  const S = content?.screens?.newPatient;
  const {
    name, mobile, otp, otpSent,
    nameError, mobileError, isSendingOtp,
    isVerifyingOtp,
  } = patientState;
  const [showLogin, setShowLogin] = useState(false);
  const navigate = useNavigate();

  const set = onPatientStateChange;

  const { user } = useAuth();
  const isVerified = isMobileVerified(mobile || user?.mobile || '');

  useEffect(() => {
    if (!user) return;
    if (!name && user.fullName) set({ name: user.fullName });
    if (!mobile && user.mobile) set({ mobile: user.mobile });
  }, [user]);
  const isNamePrefilled = !!user?.fullName;
  const isMobilePrefilled = !!user?.mobile;
  if (!S) {
    console.error("newPatient config missing from femcare-content.json");
    // return null;
  }

  const handleNameChange = (e) => {
    const val = e.target.value;
    set({
      name: val.replace(/[^a-zA-Z\s]/g, ''),
      nameError: /[^a-zA-Z\s]/.test(val)
        ? S.form.nameField.errorInvalidChars
        : '',
    });
  };

  const handleMobileChange = (e) => {
    const digits = e.target.value.replace(/\D/g, '').slice(0, 10);
    set({
      mobile: digits,
      mobileError: digits.length > 0 && !/^[6-9]/.test(digits)
        ? S.form.mobileField.errorInvalidStart
        : '',
    });
  };

  const handleOtpChange = (i, val) => {
    if (!/^\d*$/.test(val)) return;
    const next = [...otp];
    next[i] = val.slice(-1);
    set({ otp: next });
    if (val && i < S.form.otpField.length - 1) document.getElementById(`otp-${i + 1}`)?.focus();
  };

  const otpComplete = otp.every((d) => d !== '');

  const canContinue =
    name.trim().length > 0 &&
    !nameError &&
    mobile.length === 10 &&
    /^[6-9]/.test(mobile) &&
    !mobileError &&
    otpSent &&
    otpComplete;

  const handleSendOtp = async () => {
    if (isSendingOtp) return;
    if (isVerified) {
      onNext();
      return;
    }
    set({ isSendingOtp: true, mobileError: "" });
    try {
      const response = await sendQuickOtp({
        fullName: name.trim(),
        mobileNumber: mobile,
      });

      if (!response?.success) {
        if (response?.success_code === 409) {
          set({
            mobileError: response?.message || "Mobile is already registered. Please login.",
            isSendingOtp: false,
          });
          return;
        }
        throw new Error(response?.message || "Failed to send OTP");
      }

      set({ otpSent: true, mobileError: "", isSendingOtp: false });
    } catch (err) {
      if (err?.message?.toLowerCase().includes('already registered') ||
        err?.message?.toLowerCase().includes('please login')) {
        setShowLogin(true);
        set({ mobileError: err.message });
      } else {
        set({ mobileError: err.message || 'Failed to send OTP' });
      }
      set({ isSendingOtp: false });
    }
  };

  const handleContinue = async () => {
    if (isVerifyingOtp) return;

    try {
      set({ isVerifyingOtp: true, mobileError: "" });

      await verifyOtp({
        fullName: name.trim(),
        mobileNumber: mobile,
        otp: otp.join(""),
      });

      const registerResponse = await quickRegister({
        fullName: name.trim(),
        mobileNumber: mobile,
        otp: otp.join(""),
        orgName: "FemCare",
      });

      storePatientSession({
        ...registerResponse.data,
        fullName: name.trim(),
        mobile: mobile,
        isVerified: true,
      });

      const existing = JSON.parse(localStorage.getItem("patientPersona") || "{}");
      localStorage.setItem(
        "patientPersona",
        JSON.stringify({ ...existing, name: name.trim(), savedAt: Date.now() })
      );

      onNext();
    } catch (err) {
      set({ mobileError: err.message || "Verification failed" });
    } finally {
      set({ isVerifyingOtp: false });
    }
  };
if(!S) return <>Loading! </>

  return (
    <>
      {/* ── Header ── */}
      <div className="flex items-start justify-between mb-5" style={{flexWrap:"wrap"}}>
        <div className="max-w-md">
          <h1 className="text-[22px] font-bold text-[#1A1A1A] leading-tight mb-1">
            {S?.pageTitle}
          </h1>
          <p className="text-xs text-[#555555]">{S?.pageSubtitle}</p>
        </div>
        {totalSteps ? <StepperProgress current={stepIndex} total={totalSteps} /> : ""}
      </div>

      {/* ── Body ── */}
      <div className="flex gap-4 items-start flex-wrap">
        {/* Left — form */}
        <div
        //  className="flex-1 min-w-0"
        className="flex-initial md:flex-1 min-w-0"
         >
          <div className="bg-white rounded-xl border border-[#E6E0F0] p-4 flex flex-col gap-4">

            {/* Full Name */}
            <div>
              <label className="block text-[11px] font-semibold text-[#1A1A1A] mb-1">
                {S?.form.nameField.label}
              </label>
              <input
                className={`w-full border rounded-lg px-3 py-2 text-xs text-[#1A1A1A] outline-none transition-colors placeholder:text-[#BDBDBD] ${nameError ? "border-red-400 focus:border-red-500" : "border-[#E6E0F0] focus:border-[#7B1FA2]"
                  }`}
                placeholder={S?.form.nameField.placeholder}
                value={name}
                // disabled={name}
                disabled={isNamePrefilled}
                onChange={handleNameChange}
              />
              {nameError && <p className="text-[10px] text-red-500 mt-1">{nameError}</p>}
            </div>

            {/* Mobile */}
            <div>
              <label className="block text-[11px] font-semibold text-[#1A1A1A] mb-1">
                {S?.form.mobileField.label}
              </label>
              <p className="text-[10px] text-[#9CA3AF] mb-2">{S?.form.mobileField.helperText}</p>
              <div className="flex gap-2" style={{flexWrap:"wrap"}}>
                <div className="flex items-center px-3 border border-[#E6E0F0] rounded-lg text-xs text-[#1A1A1A] h-9 flex-shrink-0">
                  {S?.form.mobileField.countryCodeLabel} ▾
                </div>
                <input
                  className={`flex-1 border rounded-lg px-3 py-2 text-xs text-[#1A1A1A] outline-none transition-colors placeholder:text-[#BDBDBD] ${mobileError ? "border-red-400 focus:border-red-500" : "border-[#E6E0F0] focus:border-[#7B1FA2]"
                    }`}
                  placeholder={S?.form.mobileField.placeholder}
                  disabled={isMobilePrefilled}
                  value={mobile}
                  onChange={handleMobileChange}
                />
              </div>
              {mobileError && (
                <div className="flex justify-between items-center mt-3">
                  <p className="text-[10px] text-red-500 mt-1">{mobileError}</p>
                  {showLogin && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <button
                        type="button"
                        className="ava-text-caption hover:underline bg-transparent border-none p-0 cursor-pointer animate-bounce"
                        onClick={() => navigate(S.form.mobileField.loginInsteadUrl)}
                        style={{ color: "var(--primary-color)" }}
                      >
                        {S?.form.mobileField.loginInsteadLabel}
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* OTP / Send Button */}
            {!otpSent ? (
              <button
                disabled={mobile.length !== 10 || !!mobileError || isSendingOtp || isVerifyingOtp}
                onClick={handleSendOtp}
                className="w-full py-2.5 rounded-lg text-xs font-semibold text-white bg-[#4A148C] disabled:bg-[#BA68C8] disabled:cursor-not-allowed transition-colors hover:bg-[#38006B]"
              >
                {isSendingOtp
                  ? S?.buttons.sendOtp.sendingLabel
                  : isVerified
                    ? S?.buttons.sendOtp.alreadyVerifiedLabel
                    : S?.buttons.sendOtp.idleLabel}
              </button>
            ) : (
              <div>
                <label className="block text-[11px] font-semibold text-[#1A1A1A] mb-2">
                  {S?.form.otpField.label}
                </label>
                <div className="flex gap-2" >
                  {otp.map((v, i) => (
                    <input
                      key={i}
                      id={`otp-${i}`}
                      className={`w-11 h-13 text-center font-bold text-lg rounded-lg outline-none transition-colors ${v ? "border-2 border-[#7B1FA2] text-[#4A148C]" : "border border-[#E6E0F0] text-[#1A1A1A]"
                        }`}
                      style={{ height: "52px" }}
                      maxLength={1}
                      value={v}
                      placeholder={S?.form.otpField.placeholder}
                      onChange={(e) => handleOtpChange(i, e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Backspace" && !v && i > 0)
                          document.getElementById(`otp-${i - 1}`)?.focus();
                      }}
                    />
                  ))}
                </div>
                <button className="mt-2 text-[11px] text-[#4A148C] font-medium bg-none border-none cursor-pointer">
                  {S?.form.otpField.resendLabel}
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Right — sidebar */}
        <aside className="w-full  sm:w-[220px] flex-shrink-0 bg-white rounded-xl border border-[#E6E0F0] p-4 flex flex-col gap-3">
          <p className="text-xs font-bold text-[#1A1A1A]">{S.sideCard.title}</p>
          <ul className="text-[10px] text-[#555555] leading-relaxed pl-3.5 m-0 flex flex-col gap-1">
            {S?.sideCard.items.map((b, i) => (
              <li key={i}>{b}</li>
            ))}
          </ul>
          <div className="bg-[#EDE7F6] border border-[#CE93D8] rounded-md p-2">
            <p className="text-[10px] text-[#5E35B1] m-0 leading-relaxed">
              ℹ️ {S?.sideCard.infoBubble}
            </p>
          </div>
        </aside>
      </div>

      {/* ── Footer ── */}
      {/* <div className="flex items-center justify-between pt-3 mt-3 border-t border-[#E6E0F0]"> */}
      <div className="flex flex-col-reverse items-center justify-center gap-[6px] pt-3 mt-3 border-t border-[#E6E0F0] md:flex-row md:justify-between md:items-center">
        <BtnBack variant="outline" onClick={onBack} />
        <p className="text-[10px] text-[#9CA3AF] flex items-center gap-1">
          🔒 {S?.footNote}
        </p>
        <BtnContinue
          variant="primary"
          disabled={!canContinue || isVerifyingOtp || isSendingOtp}
          onClick={handleContinue}
          label={isVerifyingOtp ? S?.buttons.continue.verifyingLabel : S?.buttons.continue.idleLabel}
        />
      </div>
    </>
  );
}